module.exports = __webpack_public_path__ + "static/img/news1.b71e925.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news1.png
// module id = ilTv
// module chunks = 52